import { render, staticRenderFns } from "./EnteroscopiaViewComponent.vue?vue&type=template&id=7b702187"
import script from "./EnteroscopiaViewComponent.vue?vue&type=script&lang=js"
export * from "./EnteroscopiaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports